import {
  CaretDownFilled,
  CaretLeftOutlined,
  CheckCircleFilled,
  EnvironmentFilled,
  ExclamationCircleFilled,
  UserSwitchOutlined,
} from '@ant-design/icons'
import { useFormatter } from '@api/useFormatter'
import { useDirectiveContext } from '@components/Reports/DispatchDirective/DirectiveContext'
import { Horizontal, Texto, Vertical } from '@gravitate-js/excalibrr'
import React, { useEffect, useState } from 'react'

export function SelectedPriceDetails({ selectedDirective, selectedPrice }) {
  const [priceStatus, setPriceStatus] = useState({ appearance: 'secondary' })
  const { selectDirective } = useDirectiveContext()

  const { formatCurrency } = useFormatter()
  const formattedCurrency = formatCurrency(null, true)

  useEffect(() => {
    setPriceStatus({
      appearance: selectedPrice.is_low ? 'success' : 'error',
      price: selectedPrice.price,
      price_difference: selectedPrice.best_price - selectedPrice.price,
    })
  }, [selectedPrice])
  return (
    <Horizontal flex={0.75} border='all' borderRadius={3} background='bg-2' className='mb-3'>
      <Vertical verticalCenter horizontalCenter style={{ maxWidth: 30 }}>
        <div
          onClick={() => selectDirective(undefined)}
          className='header-back-button flex-1 h-100 vertical-flex-center'
        >
          <Texto category='h6' appearance='medium'>
            <CaretLeftOutlined />
          </Texto>
        </div>
      </Vertical>
      <Vertical className='pl-4' verticalCenter flex={3}>
        <Texto appearance='secondary' weight='bold'>
          {selectedDirective.name}
        </Texto>
        <Texto weight='bold' category='h4'>
          {selectedPrice.product}
        </Texto>
      </Vertical>
      <Vertical className='pl-3' verticalCenter flex={3}>
        <Texto weight={600}>
          <UserSwitchOutlined className='pr-2' /> {selectedPrice.supplier}
        </Texto>
        <Texto className='mt-2' weight={600}>
          <EnvironmentFilled className='pr-2' /> {selectedPrice.terminal}
        </Texto>
      </Vertical>
      <PriceStatusColumn priceStatus={priceStatus} formattedCurrency={formattedCurrency} />
    </Horizontal>
  )
}

function PriceStatusColumn({ priceStatus, formattedCurrency }) {
  if (priceStatus.appearance === 'success') {
    return (
      <Vertical background='theme-success-dim' verticalCenter flex={2}>
        <Horizontal>
          <Vertical className='pl-3' horizontalCenter>
            <Texto category='h2' appearance='success'>
              <CheckCircleFilled />
            </Texto>
          </Vertical>
          <Vertical className='pr-4' verticalCenter>
            <Texto category='h5' align='right' weight='bold' appearance='success'>
              Lowest Price
            </Texto>
            <Texto category='h4' align='right' weight='bold' appearance='success'>
              {formattedCurrency}
              {priceStatus.price}
            </Texto>
          </Vertical>
        </Horizontal>
      </Vertical>
    )
  }
  if (priceStatus.appearance === 'error') {
    return (
      <Vertical background='theme-warning-dim' verticalCenter flex={2}>
        <Horizontal>
          <Vertical className='pl-3' horizontalCenter>
            <Texto category='h2' appearance='warning'>
              <CaretDownFilled />
            </Texto>
          </Vertical>
          <Vertical className='pr-4' verticalCenter>
            <Texto category='h3' align='right' weight='bold' appearance='warning'>
              Sub-Optimal Price
            </Texto>
            <Horizontal>
              <Texto category='h6' align='right' weight='bold' appearance='warning'>
                {formattedCurrency}
                {priceStatus.price}
              </Texto>
              <Texto category='label' align='right' weight='bold' appearance='warning'>
                ({formattedCurrency}
                {priceStatus.priceDifference})
              </Texto>
            </Horizontal>
          </Vertical>
        </Horizontal>
      </Vertical>
    )
  }
  return (
    <Horizontal className='pl-3' background='theme-error-dim' verticalCenter flex={2}>
      <Texto category='h3' appearance='error'>
        <ExclamationCircleFilled />
      </Texto>

      <Texto className='flex-1 pr-3' category='h5' weight='bold' align='right' appearance='error'>
        No Active Prices
      </Texto>
    </Horizontal>
  )
}
